import React from 'react';
import * as styles from '../../DataExtractionTemplate.module.scss';
import { Popover, PopoverContent, PopoverTrigger, Text } from 'components/core';

const CharacteristicsPopoversList = () => {
  return (
    <Popover closeOnBlur={true} closeOnEscape={false} renderCloseButton={false}>
      <Text>
        Use this section to add and edit{' '}
        <PopoverTrigger>
          <Text component="span" className={styles.PopoverTrigger}>
            relevant details
          </Text>
        </PopoverTrigger>{' '}
        you want to collect from each group reported in each study.
      </Text>
      <PopoverContent
        aria-label="Relevant details"
        className={styles.PopoverContentText}
      >
        <Text>
          During extraction, a table will be created with a row for each detail
          and a column for each group reported in the study.
        </Text>
        <Text>
          Collecting this data will allow you to compare the differences between
          interventions.
        </Text>
        <Text>
          <strong>For example</strong>: Description of the treatment / exposure
        </Text>
      </PopoverContent>
    </Popover>
  );
};

export default CharacteristicsPopoversList;
